<template>
  <div class="box">
    <div class="type1" v-if="type === 1">
      <div class="left">
        <div class="title">
          <div class="icon">{{ num }}</div>
          {{ title }}
        </div>
      </div>
      <div class="right"></div>
    </div>
    <div class="type1 type2" v-if="type === 2">
      <div class="left">
        <div class="title">
          <div class="icon">{{ num }}</div>
          {{ title }}
        </div>
      </div>
      <div class="right"></div>
    </div>
    <div class="type1 type3" v-if="type === 3">
      <div class="left">
        <div class="title">
          <div class="icon"><i class="el-icon-check"></i></div>
          {{ title }}
        </div>
        <div class="desc">{{ desc }}</div>
      </div>
      <div class="right">
        <el-button class="button btn1" @click="chakan">查看</el-button>
        <el-button type="primary btn2" class="button" plain @click="setStep(2)"
          >修改</el-button
        >
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import selectData from "@/mixins/selectData.js";

export default {
  mixins: [selectData],
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  components: {
  },
  data() {
    return {
      title: "强制执行排查",
      num: 1,
    };
  },
  created() {},
  computed: {
    ...mapState("hetongqianshu", ["step"]),
    ...mapState("qiangzhi", {
      qiangzhiType: (state) => state.type,
      jieguo: (state) => state.jieguo,
    }),
    desc() {
      if (this.type) {
        const type = this.qiangzhiType;
        const index = this.enforceType.findIndex((res) => res.value == type);
        if (index > -1) {
          return this.enforceType[index].label;
        }
        return "";
      }
      return "";
    },
  },
  methods: {
    ...mapActions("hetongqianshu", ["setStep"]),
    ...mapActions("qiangzhi", ["setQiangzhijieguoVisible"]),
    chakan() {
      this.setQiangzhijieguoVisible(true);
    },
  },
};
</script>

<style scoped lang="scss">
@use "~@/views/hetongqianshu/step/shit/index.scss" as *;
</style>
